/**
 * Created by stonewang on 2017/8/18.
 */
import React from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import './style.css';

class PostModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      code: '',
      desc: '',
      hasChange: false,
      inputSuccess: false,
    }
    this.handleOk = this.handleOk.bind(this);
    this.resetModal = this.resetModal.bind(this);
  }

  handleOk () {
    const { code, desc, inputSuccess, hasChange } = this.state;
    if(hasChange){
      inputSuccess && this.props.onOk({ code, desc });
    }else {
      this.setState({ hasChange: !hasChange });
    }
  }

  componentWillReceiveProps (newProps) {
    if (newProps.visible) {
      this.resetModal();
    }
  }

  changeHandle (name, e) {
    if (name === 'code') {
      this.setState({
        [name]: e.target.value,
        hasChange: true,
        inputSuccess: !!e.target.value,
      });
    } else {
      this.setState({
        [name]: e.target.value,
      });
    }
  }

  resetModal () {
    this.setState({
      ...this.state,
      code: '',
      desc: '',
      hasChange: false,
      inputError: false,
    })
  }

  render () {
    const self = this;
    const { hasChange, inputSuccess, code, desc } = this.state;
    const modalOpts = {
      title: '新增货位',
      visible: self.props.visible,
      onCancel: self.props.onCancel,
      footer: [
        <Button key="0" size="large" onClick={self.props.onCancel}>取消</Button>,
        <Button key="1" type="primary" size="large" onClick={self.handleOk}>
          确定
        </Button>,
      ]
    };

    return (
      <Modal {...modalOpts} width={500}>
        <form className="ant-form ant-form-vertical">
          <div className="ant-row ant-form-item">
            <div className="ant-form-item-label">
              <label htmlFor="code"
                     className="ant-form-item-required"
                     title="货位编码">货位编码</label></div>
            <div className="ant-form-item-control-wrapper">
              <div
                className={`ant-form-item-control ${hasChange ? 'has-feedback' : ''} ${hasChange ? (inputSuccess ? 'has-success' : 'has-error') : ''}`}>
                  <input type="text"
                         placeholder="请输入货位编码"
                         value={code}
                         id="code"
                         onChange={this.changeHandle.bind(this, 'code')}
                         className="ant-input ant-input-lg"/>
                {
                  hasChange && !inputSuccess ? <div className="ant-form-explain">请输入货位编码</div> : null
                }
              </div>
            </div>
          </div>
          <div className="ant-row ant-form-item">
            <div className="ant-form-item-label">
              <label htmlFor="desc" className="" title="货位描述">货位描述</label>
            </div>
            <div className="ant-form-item-control-wrapper">
              <div className="ant-form-item-control ">
                  <textarea placeholder="请输入货位描述"
                            rows="4"
                            id="desc"
                            value={desc}
                            onChange={this.changeHandle.bind(this, 'desc')}
                            className="ant-input"/>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    )
  }
}
PostModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired
};
export default PostModal;


// WEBPACK FOOTER //
// ./src/components/postModal.js